import React, {
  FormEvent,
  FunctionComponent,
  ReactNode,
  RefObject,
  useEffect,
  useState,
} from 'react';

import { Window } from '../utils/interfaces';

import Grecaptcha from './Grecaptcha';

interface Props {
  recaptchaRequired?: boolean;
  formStyles?: string;
  grecaptchaApiKey?: string;
  onCaptchaResponse: (token: string | null) => void;
  formRef?: RefObject<HTMLFormElement>;
}

const InvisibleRecaptcha: FunctionComponent<Props & { children: ReactNode }> = (
  props
) => {
  const {
    recaptchaRequired = true,
    formStyles,
    grecaptchaApiKey,
    onCaptchaResponse,
    children,
    formRef,
  } = props;
  const [grecaptchaId, setGrecaptchaId] = useState<string | null>(null);

  useEffect(() => {
    (window as Window).newrelic?.addPageAction('Login with Password', {
      recaptchaRequired,
    });
  }, [recaptchaRequired]);

  if (!recaptchaRequired || !grecaptchaApiKey) {
    return (
      <form
        ref={formRef}
        className={formStyles}
        onSubmit={(event: FormEvent<HTMLFormElement>): void => {
          event.preventDefault();

          onCaptchaResponse(null);
        }}
      >
        {children}
      </form>
    );
  }

  const onSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    (window as Window).grecaptcha?.execute(grecaptchaId as string);
  };

  return (
    <form className={formStyles} onSubmit={onSubmit} ref={formRef}>
      {children}
      <Grecaptcha
        grecaptchaApiKey={grecaptchaApiKey}
        elementId="grecaptchaSubmitButton"
        size="invisible"
        onCaptchaResponse={onCaptchaResponse}
        setGrecaptchaId={setGrecaptchaId}
        hiddenOnMobile={false}
      />
    </form>
  );
};

export default InvisibleRecaptcha;
